const colors = {
  mostarda: '#FBD528',
  grey: '#474F59',
  lightGrey: '#F2F2F2',
  greenishGrey: '#B9BAAC',
  green: '#086A68',
  red: '#FF0000'
}

export { colors }